import { jwtDecode } from "jwt-decode";

export const isTokenValid = (token) => {
  if (!token) return false;

  try {
    const { exp } = jwtDecode(token); // exp in seconds
    return Date.now() < exp * 1000;   // compare ms
  } catch (e) {
    return false;
  }
};
